module.exports = __webpack_public_path__ + "static/media/2DGACM14.473f0ffe.jpg";